export default "__VITE_ASSET__DcaJB2Lz__"